import { render, staticRenderFns } from "./PortfolioCurrencyItem.vue?vue&type=template&id=7ada84d1&"
import script from "./PortfolioCurrencyItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioCurrencyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports